import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';

import 'moment/locale/fr';
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/it';
import 'moment/locale/nl';
import 'moment/locale/pt';
import 'moment/locale/bg';

import { TRANSLATIONS_FR } from './fr';
import { TRANSLATIONS_EN } from './en';
import { TRANSLATIONS_DE } from './de';
import { TRANSLATIONS_ES } from './es';
import { TRANSLATIONS_IT } from './it';
import { TRANSLATIONS_NL } from './nl';
import { TRANSLATIONS_PT } from './pt';
import { TRANSLATIONS_BG } from './bg';
import { updateHtmlLanguageAttributes } from '../utils/languageUtils';

const languageToMomentLocale = {
  FR: 'fr',
  EN: 'en',
  DE: 'de',
  ES: 'es',
  IT: 'it',
  NL: 'nl',
  PT: 'pt',
  BG: 'bg',
};

// Get initial language from localStorage or browser
const getInitialLanguage = () => {
  const storedLanguage = localStorage.getItem('appLanguage');
  if (storedLanguage) {
    return storedLanguage.toUpperCase();
  }

  const browserLang = (navigator.language || 'en').split('-')[0].toLowerCase();
  const supportedLanguages = ['en', 'nl', 'de', 'fr', 'it', 'es', 'pt', 'bg'];

  if (supportedLanguages.includes(browserLang)) {
    return browserLang.toUpperCase();
  }

  return 'EN';
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      FR: {
        translation: TRANSLATIONS_FR,
      },
      EN: {
        translation: TRANSLATIONS_EN,
      },
      DE: {
        translation: TRANSLATIONS_DE,
      },
      ES: {
        translation: TRANSLATIONS_ES,
      },
      IT: {
        translation: TRANSLATIONS_IT,
      },
      NL: {
        translation: TRANSLATIONS_NL,
      },
      PT: {
        translation: TRANSLATIONS_PT,
      },
      BG: {
        translation: TRANSLATIONS_BG,
      },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'EN',
  });

const initialLanguage = i18n.language || 'EN';
const momentLocale = languageToMomentLocale[initialLanguage] || 'en';
moment.locale(momentLocale);

i18n.on('languageChanged', (language) => {
  updateHtmlLanguageAttributes(language);
  const newMomentLocale = languageToMomentLocale[language] || 'en';
  moment.locale(newMomentLocale);
});

export default i18n;
